export function escapeHtml(text) {
  if (!text) return ""
  const div = document.createElement("div")
  div.textContent = text
  return div.innerHTML
}

export function escapeRegex(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

export function highlight(text, searchQuery) {
  if (!searchQuery || !text) return escapeHtml(text || "")
  const words = searchQuery.split(/\s+/).filter((w) => w.length > 0)
  let result = escapeHtml(text)
  words.forEach((word) => {
    const regex = new RegExp(`(${escapeRegex(word)})`, "gi")
    result = result.replace(regex, "<mark>$1</mark>")
  })
  return result
}
